import { useState } from 'react';
import type { DataTableRowEventHandler } from '@/components/custom/erp';
import { QuanHuyen } from '@/types/schemas';

interface UseRowSelectionReturn {
  selectedObj: QuanHuyen | null;
  selectedRowIndex: string | null;
  handleRowClick: DataTableRowEventHandler<QuanHuyen>;
  clearSelection: () => void;
}

export const useRowSelection = (): UseRowSelectionReturn => {
  const [selectedObj, setSelectedObj] = useState<QuanHuyen | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick: DataTableRowEventHandler<QuanHuyen> = params => {
    setSelectedRowIndex(params.id.toString());
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
